export default {
  init: function (viewersList) {
    this.enabled = true
    const viewersListIndexes = Array.from(Array(viewersList.length).keys())
    const viewerMain = viewersListIndexes.map(() => false)

    let that = this

    viewersList.forEach(function (viewer, i) {
      const indexArray = [...viewersListIndexes]

      const index = indexArray.indexOf(i)
      if (index > -1) {
        indexArray.splice(index, 1)
      }

      viewersList[i].addHandler('zoom', () => {
        that.handler(indexArray, viewerMain, i, viewersList)
      })
      viewersList[i].addHandler('pan', () => {
        that.handler(indexArray, viewerMain, i, viewersList)
      })
      viewersList[i].addHandler('rotate', () => {
        that.handler(indexArray, viewerMain, i, viewersList)
      })
    })
  },

  handler: function (indexArray, viewerMain, i, viewerArray) {
    if (!this.enabled) {
      return
    }

    for (const j of indexArray) {
      if (viewerMain[j]) {
        return false
      }
    }

    viewerMain[i] = true

    for (const j of indexArray) {
      viewerArray[j].viewport.zoomTo(viewerArray[i].viewport.getZoom())
      viewerArray[j].viewport.panTo(viewerArray[i].viewport.getCenter())
      viewerArray[j].viewport.setRotation(viewerArray[i].viewport.getRotation())
    }

    viewerMain[i] = false
  },

  disable: function () {
    this.enabled = false
  },

  enable: function () {
    this.enabled = true
  }
}
